import "./Filters.css";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Functions Start
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
// Functions End

// import { Country, State, City as CityController } from "country-state-city";
import { filterCities } from "../../../helpers/filterCities";

import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  TextField,
  Typography,
} from "@mui/material";
import useOnclickOutside from "react-cool-onclickoutside";
import { setValue } from "@syncfusion/ej2-base";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";

const Filters = ({ FiltersParams, setFiltersParams, defaultFilters }) => {
  const {
    PriceRange,
    PropertySize,
    PropertyType,
    PropertySubType,
    Purpose,
    City,
    Confirmation,
    LandUnit,
    Bedrooms,
    Bathrooms,
  } = FiltersParams;

  const [Cities, setCities] = useState([]);
  const [priceMax, setPriceMax] = useState(1000000000000000000);
  const [priceMin, setPriceMin] = useState(0);
  const [sizeIncr, setSizeIncr] = useState(0);
  const setPriceRange = (e) =>
    setFiltersParams({ ...FiltersParams, PriceRange: e });

  useEffect(() => {
    PriceRange[0] = parseInt(priceMin);
    PriceRange[1] = parseInt(priceMax);

    setFiltersParams({ ...FiltersParams, PriceRange: PriceRange });
  }, [priceMax, priceMin]);

  const [sizeMax, setSizeMax] = useState(30);
  const [sizeMin, setSizeMin] = useState(0);
  const [sizeMaxTop, setSizeMaxTop] = useState(30);
  useEffect(() => {
    PropertySize[0] = sizeMin;
    PropertySize[1] = sizeMax;
    setFiltersParams({ ...FiltersParams, PropertySize: PropertySize });
  }, [sizeMax, sizeMin]);
  const resetPriceMethod = () => {
    setPriceMax(1000000000000000000);
    setPriceMin(0);
  };

  const resetFilters = () => {
    //window.location.reload();
    resetSizeMethod();
    resetPriceMethod();

    setFiltersParams({ ...defaultFilters });

    // setFiltersParams({ ...defaultFilters, City: "*" });
    // setFiltersParams({ ...defaultFilters, Bathrooms:"*" });
    // setFiltersParams({ ...defaultFilters, Bedrooms: "*" });
    // setFiltersParams({ ...defaultFilters, Confirmation: "*" });
    // setFiltersParams({ ...defaultFilters, LandUnit: "*" });
  };
  useEffect(() => {
    setSizeMax(
      LandUnit === "Square Feets"
        ? 8000
        : LandUnit === "Square Yards"
        ? 1000
        : LandUnit === "Square Meters"
        ? 1000
        : 30
    );
    setSizeIncr(
      LandUnit === "Square Feets"
        ? 1000
        : LandUnit === "Square Yards"
        ? 50
        : LandUnit === "Square Meters"
        ? 100
        : 2
    );

    setSizeMaxTop(
      LandUnit === "Square Feets"
        ? 8000
        : LandUnit === "Square Yards"
        ? 1000
        : LandUnit === "Square Meters"
        ? 1000
        : 30
    );
    PropertySize[1] = sizeMax;
    // setSizeMaxTop(sizeMax);
  }, [LandUnit]);
  //LandUnit
  const resetSizeMethod = () => {
    setSizeMax(sizeMaxTop);
    setSizeMin(0);
  };
  const handleSelect = async (value) => {
    var valueArr = value.split(",");

    setCity(valueArr[valueArr.length - 2]);
  };
  const setPropertySize = (e) =>
    setFiltersParams({ ...FiltersParams, PropertySize: e });
  const setPropertyType = (e) =>
    setFiltersParams({ ...FiltersParams, PropertyType: e });

  const setPropertySubType = (e) =>
    setFiltersParams({ ...FiltersParams, PropertySubType: e });
  const setPurpose = (e) => setFiltersParams({ ...FiltersParams, Purpose: e });
  const setCity = (e) => setFiltersParams({ ...FiltersParams, City: e });
  const setBathrooms = (e) =>
    setFiltersParams({ ...FiltersParams, Bathrooms: e });
  const setBedrooms = (e) =>
    setFiltersParams({ ...FiltersParams, Bedrooms: e });
  const setConfirmation = (e) =>
    setFiltersParams({ ...FiltersParams, Confirmation: e });
  const setLandUnit = (e) =>
    setFiltersParams({ ...FiltersParams, LandUnit: e });

  const handleChangePropertyType = (e) =>
    setFiltersParams({
      ...FiltersParams,
      PropertyType: e,
      PropertySubType: "*",
    });

  const handleChangeAll = (e) =>
    setFiltersParams({
      ...FiltersParams,
      PropertyType: e,
      Bathrooms: e,
      Confirmation: e,
      Purpose: e,
    });

  // useEffect(() => setCities(CityController.getCitiesOfCountry("PK")), []);
  const [priceModel, setPriceModel] = useState(false);
  const [sizeModel, setSizeModel] = useState(false);
  const [filterModel, setFilterModel] = useState(false);
  const ref = useOnclickOutside(() => {
    setSizeModel(false);
  });
  const ref2 = useOnclickOutside(() => {
    setPriceModel(false);
  });
  return (
    <>
      <div
        onClick={() => filterModel === false && setFilterModel(true)}
        className="bg-white py-3 px-3 filter-container"
        id="FiltersContainer"
        style={{
          // display: "inline-flex",
          // flexWrap: "wrap",
          borderRadius: "7px",
          // marginBottom: "15px",
        }}
      >
        <div
          className="break d-none"
          style={{ width: "100%", display: "grid" }}
        >
          {/* <div
            style={{
              justifySelf: "left",
            }}
          >
            {" "}
            <p
              variant="overline"
              display="block"
              id="lowerBorder"
              className="border border-top-0 border-right-0 border-left-0"
            >
              Filters
              <span className="filters-plate"></span>
            </p>
          </div> */}

          <div
            id="FilterDropDown"
            style={{
              position: "absolute",
              right: "30px",
              marginLeft: "94px",
              cursor: "pointer",
              justifySelf: "right",
            }}
            onClick={() =>
              filterModel === true
                ? setFilterModel(false)
                : setFilterModel(true)
            }
          >
            {filterModel === true && (
              <Button
                onClick={() => resetFilters()}
                id="myButton2"
                style={{
                  borderRadius: "5px",
                  width: "50px",
                  fontSize: "14px",
                  fontFamily: "Poppins",
                  fontWeight: "400px",
                  textTransform: "capitalize",
                  background: "white",
                  border: "1px solid #4e36a8",
                  color: "#4e36a8",
                  textAlign: "center",
                  alignSelf: "center",
                  top: "6px",
                  paddingRight: 10,
                }}
                variant="caption"
                display="block"
                gutterBottom
                className="mt-1"
              >
                Reset
              </Button>
            )}
            {filterModel === false ? (
              <svg
                style={{
                  position: "relative",
                  marginLeft: "28px",
                  marginTop: "3px",
                  top: "5px",
                }}
                className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
                viewBox="0 0 24 24"
                data-testid="ArrowDropDownIcon"
              >
                <path d="M7 10l5 5 5-5z"></path>
              </svg>
            ) : (
              <svg
                style={{
                  position: "relative",
                  marginLeft: "28px",
                  paddingTop: "4px",
                  paddingLeft: "6px",
                  top: "5px",
                }}
                className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
                viewBox="0 0 24 24"
                data-testid="ArrowDropDownIcon"
              >
                {" "}
                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />{" "}
              </svg>
            )}
          </div>
        </div>
        <div className="filter-elements">
          <p className="custom-heading">Filters</p>
          <div>
            {filterModel === true && (
              <button
                style={{
                  marginRight: 25,
                  padding: "6px 12px",
                }}
                className="reset-filter-btn"
                onClick={() => resetFilters()}
              >
                Reset
              </button>
            )}
            {filterModel === false ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34.588"
                height="34.588"
                viewBox="0 0 34.588 34.588"
                onClick={() =>
                  filterModel === true
                    ? setFilterModel(false)
                    : setFilterModel(true)
                }
              >
                <g
                  id="up-arrow-svgrepo-com"
                  transform="translate(34.588 33.995) rotate(179)"
                >
                  <g id="Group_5" data-name="Group 5">
                    <path
                      id="Path_19"
                      data-name="Path 19"
                      d="M33.741,17.37h0a16.371,16.371,0,0,1-16.37,16.37h0A16.371,16.371,0,0,1,1,17.37H1A16.371,16.371,0,0,1,17.37,1h0A16.371,16.371,0,0,1,33.741,17.37Z"
                      transform="translate(-0.37 -0.37)"
                      fill="#4c3ca6"
                    />
                    <path
                      id="Path_20"
                      data-name="Path 20"
                      d="M17,34A17,17,0,1,1,34,17,17.019,17.019,0,0,1,17,34ZM17,1.259A15.741,15.741,0,1,0,32.741,17,15.759,15.759,0,0,0,17,1.259Z"
                      fill="#4c3ca6"
                    />
                  </g>
                  <g
                    id="Group_6"
                    data-name="Group 6"
                    transform="translate(10.702 10.393)"
                  >
                    <path
                      id="Path_21"
                      data-name="Path 21"
                      d="M24.307,17.727l5.49,9.508a.438.438,0,0,1-.379.657H18.438a.438.438,0,0,1-.379-.657l5.49-9.508A.437.437,0,0,1,24.307,17.727Z"
                      transform="translate(-17.368 -16.878)"
                      fill="#fff"
                    />
                    <path
                      id="Path_22"
                      data-name="Path 22"
                      d="M29.046,28.151H18.067a1.068,1.068,0,0,1-.925-1.6l5.49-9.509a1.068,1.068,0,0,1,1.85,0l5.49,9.509a1.068,1.068,0,0,1-.925,1.6ZM18.4,26.891H28.714l-5.157-8.933Z"
                      transform="translate(-16.997 -16.507)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
            ) : (
              <svg
                id="arrow-up"
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
                onClick={() =>
                  filterModel === true
                    ? setFilterModel(false)
                    : setFilterModel(true)
                }
              >
                <g id="Group_5" data-name="Group 5">
                  <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M33.741,17.37h0a16.371,16.371,0,0,1-16.37,16.37h0A16.371,16.371,0,0,1,1,17.37H1A16.371,16.371,0,0,1,17.37,1h0A16.371,16.371,0,0,1,33.741,17.37Z"
                    transform="translate(-0.37 -0.37)"
                    fill="#4c3ca6"
                  />
                  <path
                    id="Path_20"
                    data-name="Path 20"
                    d="M17,34A17,17,0,1,1,34,17,17.019,17.019,0,0,1,17,34ZM17,1.259A15.741,15.741,0,1,0,32.741,17,15.759,15.759,0,0,0,17,1.259Z"
                    fill="#4c3ca6"
                  />
                </g>
                <g
                  id="Group_6"
                  data-name="Group 6"
                  transform="translate(10.702 10.393)"
                >
                  <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M24.307,17.727l5.49,9.508a.438.438,0,0,1-.379.657H18.438a.438.438,0,0,1-.379-.657l5.49-9.508A.437.437,0,0,1,24.307,17.727Z"
                    transform="translate(-17.368 -16.878)"
                    fill="#fff"
                  />
                  <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M29.046,28.151H18.067a1.068,1.068,0,0,1-.925-1.6l5.49-9.509a1.068,1.068,0,0,1,1.85,0l5.49,9.509a1.068,1.068,0,0,1-.925,1.6ZM18.4,26.891H28.714l-5.157-8.933Z"
                    transform="translate(-16.997 -16.507)"
                    fill="#fff"
                  />
                </g>
              </svg>
            )}
          </div>
        </div>

        {filterModel === true && (
          <div
            style={{
              display: "inline-flex",
              flexWrap: "wrap",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                zIndex: 2,
              }}
            >
              {" "}
              <div
                id="filterContainer"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  marginBottom: "20px",
                  marginRight: "20px",
                  padding: "2px",
                  width: "200px",
                  height: "63px",
                }}
              >
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  className="mt-1"
                  style={{
                    paddingLeft: "10px",
                  }}
                >
                  City
                </Typography>
                <PlacesAutocomplete
                  value={City === "*" ? "All" : City}
                  onChange={setCity}
                  onSelect={handleSelect}
                  searchOptions={{
                    types: ["(cities)"],
                    componentRestrictions: { country: "pk" },
                  }}
                  className="loc-auto-complete-city"
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => (
                    <div>
                      <input
                        className="loc-auto-complete-city"
                        {...getInputProps({ placeholder: "City" })}
                      />

                      <div>
                        {loading ? (
                          <div className="loc-auto-complete-content">
                            loading...
                          </div>
                        ) : null}

                        {suggestions.map((suggestion) => {
                          const style = {
                            backgroundColor: suggestion.active
                              ? "#c9c2e4"
                              : "#fff",
                          };

                          return (
                            <div
                              className="loc-auto-complete-content"
                              {...getSuggestionItemProps(suggestion, { style })}
                            >
                              {suggestion.description}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>

                {/* {Cities && (
                  <Autocomplete
                    // style={{ height: '20px !important', border: '1px solid black !important' }}
                    style={{
                      color: "black",
                      padding: 0,
                      margin: 0,
                    }}
                    id="filterSelectContent"
                    options={Cities}
                    autoHighlight={true}
                    getOptionLabel={(option) => option.name}
                    onChange={(e, value) => setCity(value.name)}
                    value={Cities.filter(({ name }) => name === City).pop()}
                    filterOptions={(options, state) =>
                      filterCities(options, state)
                    }
                    renderOption={(props, option) => (
                      <MenuItem {...props} id={option.id}>
                        {<p>{option.name}</p>}
                      </MenuItem>
                    )}
                    renderInput={(params) => {
                      return (
                        <TextField
                          style={{
                            padding: 0,
                            margin: 0,
                          }}
                          {...params}
                          size="small"
                          placeholder="Search City"
                        />
                      );
                    }}
                  />
                )} */}
                {/* <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={City}
         onChange={(e) => setCity(e.target.value)}
         defaultValue={City}
         size="small"
         className="w-100"
         variant="outlined"
       >
         <MenuItem value={"*"}>All</MenuItem>
         {Cities &&
           Cities.map((city) => <MenuItem value={city}>{city}</MenuItem>)}
       </Select> */}
              </div>
            </div>

            <div>
              <div
                id="filterContainer"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  marginBottom: "20px",
                  marginRight: "20px",
                  padding: "2px",
                  width: "200px",
                }}
              >
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  className="mt-1"
                  style={{
                    paddingLeft: "10px",
                  }}
                >
                  Type
                </Typography>

                <Select
                  style={{
                    border: "0px !important",
                  }}
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    ".Mui-focused": { border: 0 },
                    ".MuiOutlinedInput-root": {
                      fontWeight: 800,
                      fontSize: "18px",
                      outline: "none",
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="filterSelectContent"
                  value={PropertyType}
                  //   label="Age"
                  onChange={(e) => handleChangePropertyType(e.target.value)}
                  defaultValue={PropertyType}
                  size="small"
                  className="w-100"
                  variant="outlined"
                >
                  <MenuItem value={"Home"}>Home</MenuItem>
                  <MenuItem value={"Plot"}>Plot</MenuItem>
                  <MenuItem value={"Commercial"}>Commercial</MenuItem>
                  <MenuItem value={"*"}>All</MenuItem>
                </Select>
              </div>
            </div>

            {PropertyType !== "*" && (
              <div>
                {" "}
                <div
                  id="filterContainer"
                  style={{
                    border: "1px solid lightgrey",
                    marginBottom: "20px",
                    marginRight: "20px",
                    padding: "2px",
                    width: "200px",
                    borderRadius: "5px",
                  }}
                >
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    className="mt-1"
                    style={{
                      paddingLeft: "10px",
                    }}
                  >
                    Property Sub Type
                  </Typography>

                  {PropertyType === "Home" && (
                    <Select
                      style={{
                        border: "0",
                        outline: "none",
                      }}
                      labelId="demo-simple-select-label"
                      sx={{
                        boxShadow: "none",
                        ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        ".Mui-focused": { border: 0 },
                        ".MuiOutlinedInput-root": {
                          fontWeight: 800,
                          fontSize: "18px",
                        },
                      }}
                      id="filterSelectContent"
                      defaultValue={PropertySubType}
                      //   label="Age"
                      onChange={(e) => setPropertySubType(e.target.value)}
                      size="small"
                      className="w-100"
                      classes={"newClass"}
                      variant="outlined"
                    >
                      <MenuItem value={"House"}>House</MenuItem>
                      <MenuItem value={"Flat"}>Flat</MenuItem>
                      <MenuItem value={"Upper Portion"}>Upper Portion</MenuItem>
                      <MenuItem value={"Lower Portion"}>Lower Portion</MenuItem>
                      <MenuItem value={"Farm House"}>Farm House</MenuItem>
                      <MenuItem value={"Room"}>Room</MenuItem>
                      <MenuItem value={"Pent House"}>Pent House</MenuItem>
                      <MenuItem value={"*"}>All</MenuItem>
                    </Select>
                  )}

                  {PropertyType === "Plot" && (
                    <Select
                      // style={{
                      //   color: "black",
                      //   border: "1px solid black",
                      // }}
                      sx={{
                        boxShadow: "none",
                        ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        ".Mui-focused": { border: 0 },
                        ".MuiOutlinedInput-root": {
                          fontWeight: 800,
                          fontSize: "18px",
                        },
                      }}
                      labelId="demo-simple-select-label"
                      id="filterSelectContent"
                      defaultValue={PropertySubType}
                      //   label="Age"
                      onChange={(e) => setPropertySubType(e.target.value)}
                      size="small"
                      className="w-100"
                      variant="outlined"
                    >
                      <MenuItem value={"Residential Plot"}>
                        Residential Plot
                      </MenuItem>
                      <MenuItem value={"Commercial Plot"}>
                        Commercial Plot
                      </MenuItem>
                      <MenuItem value={"Agriculture Plot"}>
                        Agriculture Plot
                      </MenuItem>
                      <MenuItem value={"Industrial Plot"}>
                        Industrial Plot
                      </MenuItem>
                      <MenuItem value={"*"}>All</MenuItem>
                    </Select>
                  )}
                  {PropertyType === "Commercial" && (
                    <Select
                      // style={{
                      //   color: "black",
                      //   border: "1px solid black",
                      // }}
                      sx={{
                        boxShadow: "none",
                        ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        ".Mui-focused": { border: 0 },
                        ".MuiOutlinedInput-root": {
                          fontWeight: 800,
                          fontSize: "18px",
                        },
                      }}
                      labelId="demo-simple-select-label"
                      id="filterSelectContent"
                      defaultValue={PropertySubType}
                      //   label="Age"
                      onChange={(e) => setPropertySubType(e.target.value)}
                      size="small"
                      className="w-100"
                      variant="outlined"
                    >
                      <MenuItem value={"Office"}>Office</MenuItem>
                      <MenuItem value={"Shop"}>Shop</MenuItem>
                      <MenuItem value={"Warehouse"}>Warehouse</MenuItem>
                      <MenuItem value={"Building"}>Building</MenuItem>
                      <MenuItem value={"Other"}>Other</MenuItem>
                      <MenuItem value={"*"}>All</MenuItem>
                    </Select>
                  )}
                </div>
              </div>
            )}

            <div>
              <div
                id="filterContainer"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  marginBottom: "5px",
                  marginRight: "20px",
                  padding: "0px",
                  width: "240px",
                  height: "63px",
                  cursor: "pointer",
                }}
              >
                <Typography
                  Typevariant="caption"
                  display="block"
                  gutterBottom
                  className="mt-1"
                  style={{
                    paddingLeft: "10px",
                    fontSize: "0.75rem",
                  }}
                >
                  Price ( PKR )
                </Typography>

                <div
                  style={{
                    display: "inline-flex",
                    flexWrap: "wrap",
                    marginTop: 5,
                  }}
                >
                  <p
                    style={{
                      marginLeft: 10,
                      fontWeight: "bold",
                      fontSize: "16px",
                      width: "60px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {PriceRange[0].toLocaleString()}
                  </p>
                  <p
                    style={{
                      marginLeft: 10,
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                  >
                    to
                  </p>
                  <p
                    style={{
                      marginLeft: 10,
                      fontWeight: "bold",
                      fontSize: "16px",
                      width: "60px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {PriceRange[1].toLocaleString()}
                  </p>

                  {/* onClick={setPriceModel(true)} */}
                  <div
                    style={{
                      marginBottom: "19px",
                    }}
                    onClick={
                      () => {
                        setPriceModel(!priceModel);
                      }

                      //   : setPriceModel(true)
                    }
                  >
                    {priceModel === false ? (
                      <svg
                        style={{
                          position: "initial",
                          marginLeft: "37px",
                        }}
                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
                        viewBox="0 0 24 24"
                        data-testid="ArrowDropDownIcon"
                      >
                        <path d="M7 10l5 5 5-5z"></path>
                      </svg>
                    ) : (
                      <svg
                        style={{
                          position: "initial",
                          marginLeft: "37px",
                          paddingTop: "4px",
                          paddingLeft: "6px",
                        }}
                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
                        viewBox="0 0 24 24"
                        data-testid="ArrowDropDownIcon"
                      >
                        {" "}
                        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />{" "}
                      </svg>
                    )}
                  </div>
                </div>
              </div>

              {priceModel === true && (
                <div
                  className="dropDownStyle"
                  ref={ref2}
                  style={{
                    top: "330px",
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      className="d-flex justify-content-evenly my-2"
                      style={{
                        marginLeft: "10px",
                        marginRight: "15px",
                      }}
                    >
                      <div>
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                        >
                          Min
                        </Typography>
                        <TextField
                          style={{
                            color: "black",
                            border: "1px solid lightgrey",
                            borderRadius: "5px",
                          }}
                          type="number"
                          min="0"
                          id="outlined-size-small"
                          defaultValue={PriceRange[0]}
                          value={
                            PriceRange[0] < 0
                              ? 0
                              : PriceRange[0] > PriceRange[1]
                              ? PriceRange[1]
                              : PriceRange[0]
                          }
                          onChange={(e) =>
                            setPriceMin(
                              e.target.value < 0
                                ? 0
                                : e.target.value > PriceRange[1]
                                ? PriceRange[1]
                                : e.target.value
                            )
                          }
                          size="small"
                          className="col-11"
                        />
                      </div>

                      <div>
                        <Typography
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                        >
                          Max
                        </Typography>
                        <TextField
                          style={{
                            color: "black",
                            border: "1px solid lightgrey",
                            borderRadius: "5px",
                          }}
                          onChange={(e) =>
                            setPriceMax(
                              e.target.value < 0
                                ? 0
                                : e.target.value < PriceRange[0]
                                ? PriceRange[0]
                                : e.target.value
                            )
                          }
                          id="outlined-size-small"
                          type="number"
                          min="0"
                          defaultValue={PriceRange[1]}
                          value={
                            PriceRange[1] < 0
                              ? 0
                              : PriceRange[1] < PriceRange[0]
                              ? PriceRange[0]
                              : PriceRange[1]
                          }
                          size="small"
                          className="col-12"
                        />
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-evenly my-2"
                      style={{
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                    >
                      <div
                        style={{
                          marginRight: 5,
                          overflowX: "hidden",
                          overflowY: "scroll",
                          height: 150,
                        }}
                      >
                        <Button
                          id={priceMin === 0 ? "myButton2" : "myButton"}
                          onClick={() => setPriceMin(0)}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                        >
                          0
                        </Button>
                        <Button
                          id={priceMin === 100000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMin(100000)}
                        >
                          100,000
                        </Button>
                        <Button
                          id={priceMin === 300000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMin(300000)}
                        >
                          300,000
                        </Button>

                        <Button
                          id={priceMin === 700000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMin(700000)}
                        >
                          700,000
                        </Button>

                        <Button
                          id={priceMin === 900000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMin(900000)}
                        >
                          900,000
                        </Button>
                      </div>

                      <div
                        style={{
                          marginRight: 5,
                          overflowX: "hidden",
                          overflowY: "scroll",
                          height: 150,
                        }}
                      >
                        <Button
                          id={
                            priceMax === 1000000000000000000
                              ? "myButton2"
                              : "myButton"
                          }
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMax(1000000000000000000)}
                        >
                          Any
                        </Button>

                        <Button
                          id={priceMax === 1200000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMax(1200000)}
                        >
                          1200,000
                        </Button>
                        <Button
                          id={priceMax === 1600000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMax(1600000)}
                        >
                          1600,000
                        </Button>

                        <Button
                          id={priceMax === 2200000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMax(2200000)}
                        >
                          2200,000
                        </Button>

                        <Button
                          id={priceMax === 2500000 ? "myButton2" : "myButton"}
                          variant="caption"
                          display="block"
                          gutterBottom
                          className="mt-1"
                          onClick={() => setPriceMax(2500000)}
                        >
                          2500,000
                        </Button>
                      </div>
                    </div>
                    <Button
                      id="myButton"
                      onClick={() => resetPriceMethod()}
                      style={{
                        marginLeft: "101px",
                        color: "#4e36a8",
                        borderTop: 0,
                        borderBottom: 0,
                        borderLeft: 0,
                        borderRight: 0,
                        width: "30px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        fontWeight: "400px",
                        textTransform: "capitalize",
                      }}
                      variant="caption"
                      display="block"
                      gutterBottom
                      className="mt-1"
                    >
                      Reset
                    </Button>
                    <Button
                      onClick={() => setPriceModel(!priceModel)}
                      id="myButton2"
                      style={{
                        borderRadius: "5px",
                        width: "50px",
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        fontWeight: "400px",
                        textTransform: "capitalize",
                      }}
                      variant="caption"
                      display="block"
                      gutterBottom
                      className="mt-1"
                    >
                      Close
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div>
              {" "}
              <div
                id="filterContainer"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  marginBottom: "20px",
                  marginRight: "20px",
                  padding: "2px",
                  width: "200px",
                }}
              >
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  className="mt-1"
                  style={{
                    paddingLeft: "10px",
                  }}
                >
                  Purpose
                </Typography>

                <Select
                  // style={{
                  //   color: "black",
                  //   border: "1px solid black",
                  // }}
                  // name="Purpose"
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    ".Mui-focused": { border: 0 },
                    ".MuiOutlinedInput-root": {
                      fontWeight: 800,
                      fontSize: "18px",
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="filterSelectContent"
                  value={Purpose}
                  //   label="Age"
                  onChange={(e) => setPurpose(e.target.value)}
                  size="small"
                  className="w-100"
                  variant="outlined"
                >
                  <MenuItem value={"*"}>Any</MenuItem>
                  <MenuItem value={"rent"}>Rent</MenuItem>
                  <MenuItem value={"sale"}>Sale</MenuItem>
                  {/* <MenuItem value={"Family"}>Family</MenuItem>
                  <MenuItem value={"Office"}>Office</MenuItem> */}
                </Select>
              </div>
            </div>
            <div>
              <div
                id="filterContainer"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",

                  marginBottom: "20px",
                  marginRight: "20px",
                  padding: "2px",
                  width: "200px",
                }}
              >
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  className="mt-1"
                  style={{
                    paddingLeft: "10px",
                  }}
                >
                  Confirmation
                </Typography>

                <Select
                  // style={{
                  //   color: "black",
                  //   border: "1px solid black",
                  // }}
                  sx={{
                    boxShadow: "none",
                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    ".Mui-focused": { border: 0 },
                    ".MuiOutlinedInput-root": {
                      fontWeight: 800,
                      fontSize: "18px",
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="filterSelectContent"
                  value={Confirmation}
                  //   label="Age"
                  onChange={(e) => setConfirmation(e.target.value)}
                  size="small"
                  className="w-100"
                  variant="outlined"
                >
                  <MenuItem value={"*"}>Any</MenuItem>
                  <MenuItem value={"confirmed"}>Confirmed</MenuItem>
                  <MenuItem value={"not-confirmed"}>Not Confirmed</MenuItem>
                </Select>
              </div>
            </div>
            {PropertyType !== "Plot" && (
              <div>
                {" "}
                <div
                  id="filterContainer"
                  style={{
                    border: "1px solid lightgrey",
                    borderRadius: "5px",
                    marginBottom: "20px",
                    marginRight: "20px",
                    padding: "2px",
                    width: "200px",
                  }}
                >
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    className="mt-1"
                    style={{
                      paddingLeft: "10px",
                    }}
                  >
                    Bathrooms
                  </Typography>

                  <Select
                    // style={{
                    //   color: "black",
                    //   border: "1px solid black",
                    // }}
                    sx={{
                      boxShadow: "none",
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      ".Mui-focused": { border: 0 },
                      ".MuiOutlinedInput-root": {
                        fontWeight: 800,
                        fontSize: "18px",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="filterSelectContent"
                    value={Bathrooms}
                    //   label="Age"
                    onChange={(e) => setBathrooms(e.target.value)}
                    size="small"
                    className="w-100"
                    variant="outlined"
                  >
                    <MenuItem value={"*"}>Any</MenuItem>
                    <MenuItem value={"Studio"}>Studio</MenuItem>
                    <MenuItem value={"1"}>1</MenuItem>
                    <MenuItem value={"2"}>2</MenuItem>
                    <MenuItem value={"3"}>3</MenuItem>
                    <MenuItem value={"4"}>4</MenuItem>
                    <MenuItem value={"5"}>5</MenuItem>
                    <MenuItem value={"6"}>6</MenuItem>
                    <MenuItem value={"7"}>7</MenuItem>
                    <MenuItem value={"8"}>8</MenuItem>
                    <MenuItem value={"9"}>9</MenuItem>
                    <MenuItem value={"10"}>10</MenuItem>
                    <MenuItem value={"10+"}>10+</MenuItem>
                  </Select>
                </div>
              </div>
            )}
            {PropertyType !== "Plot" && (
              <div>
                <div
                  id="filterContainer"
                  style={{
                    border: "1px solid lightgrey",
                    borderRadius: "5px",
                    marginBottom: "20px",
                    marginRight: "20px",
                    padding: "2px",
                    width: "200px",
                  }}
                >
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    className="mt-1"
                    style={{
                      paddingLeft: "10px",
                    }}
                  >
                    Bedrooms
                  </Typography>

                  <Select
                    // style={{
                    //   color: "black",
                    //   border: "1px solid black",
                    // }}
                    sx={{
                      boxShadow: "none",
                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                      ".Mui-focused": { border: 0 },
                      ".MuiOutlinedInput-root": {
                        fontWeight: 800,
                        fontSize: "18px",
                      },
                    }}
                    labelId="demo-simple-select-label"
                    id="filterSelectContent"
                    value={Bedrooms}
                    //   label="Age"
                    onChange={(e) => setBedrooms(e.target.value)}
                    size="small"
                    className="w-100"
                    variant="outlined"
                  >
                    <MenuItem value={"*"}>Any</MenuItem>
                    <MenuItem value={"1"}>1</MenuItem>
                    <MenuItem value={"2"}>2</MenuItem>
                    <MenuItem value={"3"}>3</MenuItem>
                    <MenuItem value={"4"}>4</MenuItem>
                    <MenuItem value={"5"}>5</MenuItem>
                    <MenuItem value={"6"}>6</MenuItem>
                    <MenuItem value={"7"}>7</MenuItem>
                    <MenuItem value={"8"}>8</MenuItem>
                    <MenuItem value={"9"}>9</MenuItem>
                    <MenuItem value={"10"}>10</MenuItem>
                  </Select>
                </div>
              </div>
            )}

            <div>
              <div
                id="filterContainer"
                style={{
                  border: "1px solid lightgrey",
                  borderRadius: "5px",
                  marginBottom: "20px",
                  marginRight: "20px",
                  padding: "2px",
                  width: "200px",
                }}
              >
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  className="mt-1"
                  style={{
                    paddingLeft: "10px",
                  }}
                >
                  Land Unit
                </Typography>

                <Select
                  style={{
                    border: "0px !important",
                  }}
                  sx={{
                    boxShadow: "none",

                    ".MuiOutlinedInput-notchedOutline": { border: 0 },
                    ".Mui-focused": { border: 0 },
                    ".MuiOutlinedInput-root": {
                      fontWeight: 800,
                      fontSize: "18px",
                    },
                  }}
                  labelId="demo-simple-select-label"
                  id="filterSelectContent"
                  value={LandUnit}
                  //   label="Age"
                  onChange={(e) => setLandUnit(e.target.value)}
                  size="small"
                  className="w-100"
                  variant="outlined"
                >
                  <MenuItem value={"Square Feets"}>Square Feets</MenuItem>
                  <MenuItem value={"Square Yards"}>Square Yards</MenuItem>
                  <MenuItem value={"Square Meters"}>Square Meters</MenuItem>
                  <MenuItem value={"Marla"}>Marla</MenuItem>
                  <MenuItem value={"Kanal"}>Kanal</MenuItem>
                  <MenuItem value={"*"}>All</MenuItem>
                </Select>
              </div>
            </div>
            {LandUnit !== "*" && (
              <div>
                <div
                  id="filterContainer"
                  style={{
                    border: "1px solid lightgrey",
                    borderRadius: "5px",
                    marginBottom: "5px",
                    marginRight: "20px",
                    padding: "0px",
                    width: "240px",
                    height: "63px",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    Typevariant="caption"
                    display="block"
                    gutterBottom
                    className="mt-1"
                    style={{
                      paddingLeft: "10px",
                      fontSize: "0.75rem",
                    }}
                  >
                    Size
                  </Typography>
                  <div
                    style={{
                      display: "inline-flex",
                      flexWrap: "wrap",
                      marginTop: 5,
                    }}
                  >
                    <p
                      style={{
                        marginLeft: 10,
                        fontWeight: "bold",
                        fontSize: "16px",
                        width: "60px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {PropertySize[0].toLocaleString()}
                    </p>
                    <p
                      style={{
                        marginLeft: 10,
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      to
                    </p>
                    <p
                      style={{
                        marginLeft: 10,
                        fontWeight: "bold",
                        fontSize: "16px",
                        width: "60px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {PropertySize[1].toLocaleString()}
                    </p>

                    <div
                      style={{
                        marginBottom: "19px",
                      }}
                      onClick={() =>
                        sizeModel === true
                          ? setSizeModel(false)
                          : setSizeModel(true)
                      }
                    >
                      {sizeModel === false ? (
                        <svg
                          style={{
                            position: "initial",
                            marginLeft: "37px",
                          }}
                          className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
                          viewBox="0 0 24 24"
                          data-testid="ArrowDropDownIcon"
                        >
                          <path d="M7 10l5 5 5-5z"></path>
                        </svg>
                      ) : (
                        <svg
                          style={{
                            position: "initial",
                            marginLeft: "37px",
                            paddingTop: "4px",
                            paddingLeft: "6px",
                          }}
                          className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
                          viewBox="0 0 24 24"
                          data-testid="ArrowDropDownIcon"
                        >
                          {" "}
                          <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />{" "}
                        </svg>
                      )}
                    </div>
                  </div>
                </div>

                {sizeModel === true && (
                  <div
                    className="dropDownStyle"
                    ref={ref}
                    style={{
                      top: "413px",
                    }}
                  >
                    <div
                      style={{
                        display: "inline-flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        className="d-flex justify-content-evenly my-2"
                        style={{
                          marginLeft: "10px",
                          marginRight: "15px",
                        }}
                      >
                        <div>
                          <Typography
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            Min
                          </Typography>
                          <TextField
                            style={{
                              color: "black",
                              border: "1px solid lightgrey",
                              borderRadius: "5px",
                            }}
                            id="outlined-size-small"
                            type="number"
                            min="0"
                            defaultValue={PropertySize[0]}
                            value={PropertySize[0] < 0 ? 0 : PropertySize[0]}
                            onChange={(e) =>
                              setSizeMin(
                                e.target.value < 0
                                  ? 0
                                  : e.target.value > PropertySize[1]
                                  ? PropertySize[1]
                                  : e.target.value
                              )
                            }
                            size="small"
                            className="col-11"
                          />
                        </div>

                        <div>
                          <Typography
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            Max
                          </Typography>
                          <TextField
                            style={{
                              color: "black",
                              border: "1px solid lightgrey",
                              borderRadius: "5px",
                            }}
                            id="outlined-size-small"
                            defaultValue={PropertySize[1]}
                            value={PropertySize[1] < 0 ? 0 : PropertySize[1]}
                            type="number"
                            min="0"
                            onChange={(e) =>
                              setSizeMax(
                                e.target.value < 0
                                  ? 0
                                  : e.target.value >= 100000
                                  ? 0
                                  : e.target.value < PropertySize[0]
                                  ? PropertySize[0]
                                  : e.target.value
                              )
                            }
                            size="small"
                            className="col-12"
                          />
                        </div>
                      </div>
                      <div
                        className="d-flex justify-content-evenly my-2"
                        style={{
                          marginLeft: "5px",
                          marginRight: "5px",
                        }}
                      >
                        <div
                          style={{
                            marginRight: 5,

                            overflowX: "hidden",
                            overflowY: "scroll",
                            height: 150,
                          }}
                        >
                          <Button
                            id={sizeMin === 0 ? "myButton2" : "myButton"}
                            onClick={() => setSizeMin(0)}
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeIncr - sizeIncr}
                          </Button>
                          <Button
                            id={sizeMin === sizeIncr ? "myButton2" : "myButton"}
                            onClick={() => setSizeMin(sizeIncr - 0)}
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeIncr - 0}
                          </Button>
                          <Button
                            id={
                              sizeMin === sizeIncr + sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() => setSizeMin(sizeIncr + sizeIncr)}
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeIncr + sizeIncr}
                          </Button>

                          <Button
                            id={
                              sizeMin === sizeIncr + sizeIncr + sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() =>
                              setSizeMin(sizeIncr + sizeIncr + sizeIncr)
                            }
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeIncr + sizeIncr + sizeIncr}
                          </Button>

                          <Button
                            id={
                              sizeMin ===
                              sizeIncr + sizeIncr + sizeIncr + sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() =>
                              setSizeMin(
                                sizeIncr + sizeIncr + sizeIncr + sizeIncr
                              )
                            }
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeIncr + sizeIncr + sizeIncr + sizeIncr}
                          </Button>
                        </div>

                        <div
                          style={{
                            marginRight: 5,

                            overflowX: "hidden",
                            overflowY: "scroll",
                            height: 150,
                          }}
                        >
                          <Button
                            id={
                              sizeMax === sizeMaxTop ? "myButton2" : "myButton"
                            }
                            onClick={() => setSizeMax(sizeMax)}
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            Any
                          </Button>
                          <Button
                            id={
                              sizeMax === sizeMaxTop - sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() => setSizeMax(sizeMaxTop - sizeIncr)}
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeMaxTop - sizeIncr}
                          </Button>

                          <Button
                            id={
                              sizeMax === sizeMaxTop - sizeIncr - sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() =>
                              setSizeMax(sizeMaxTop - sizeIncr - sizeIncr)
                            }
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeMaxTop - sizeIncr - sizeIncr}
                          </Button>

                          <Button
                            id={
                              sizeMax ===
                              sizeMaxTop - sizeIncr - sizeIncr - sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() =>
                              setSizeMax(
                                sizeMaxTop - sizeIncr - sizeIncr - sizeIncr
                              )
                            }
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeMaxTop - sizeIncr - sizeIncr - sizeIncr}
                          </Button>

                          <Button
                            id={
                              sizeMax ===
                              sizeMaxTop -
                                sizeIncr -
                                sizeIncr -
                                sizeIncr -
                                sizeIncr
                                ? "myButton2"
                                : "myButton"
                            }
                            onClick={() =>
                              setSizeMax(
                                sizeMaxTop -
                                  sizeIncr -
                                  sizeIncr -
                                  sizeIncr -
                                  sizeIncr
                              )
                            }
                            variant="caption"
                            display="block"
                            gutterBottom
                            className="mt-1"
                          >
                            {sizeMaxTop -
                              sizeIncr -
                              sizeIncr -
                              sizeIncr -
                              sizeIncr}
                          </Button>
                        </div>
                      </div>
                      <Button
                        id="myButton"
                        onClick={() => resetSizeMethod()}
                        style={{
                          color: "#4e36a8",
                          borderTop: 0,
                          borderBottom: 0,
                          borderLeft: 0,
                          borderRight: 0,
                          marginLeft: "101px",
                          width: "30px",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          fontWeight: "400px",
                          textTransform: "capitalize",
                        }}
                        variant="caption"
                        display="block"
                        gutterBottom
                        className="mt-1"
                      >
                        Reset
                      </Button>
                      <Button
                        onClick={() =>
                          sizeModel === true
                            ? setSizeModel(false)
                            : setSizeModel(true)
                        }
                        id="myButton2"
                        style={{
                          borderRadius: "5px",
                          width: "50px",
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          fontWeight: "400px",
                          textTransform: "capitalize",
                        }}
                        variant="caption"
                        display="block"
                        gutterBottom
                        className="mt-1"
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* {LandUnit !=== "*" && (
         <div
           style={{
             border: "1px solid lightgrey",
             marginBottom: "20px",
             marginRight: "20px",
             padding: "2px",
             width: "200px",
           }}
         >
           <Typography
             variant="caption"
             display="block"
             gutterBottom
             className="mt-1"
             style={{
               paddingLeft: "10px",
             }}
           >
             Property Size
           </Typography>

           <Slider
             getAriaLabel={() => "Temperature range"}
             min={1}
             max={50}
             step={1}
             defaultValue={PropertySize}
             onChangeCommitted={(e, value) => setPropertySize(value)}
             valueLabelDisplay="auto"
           />


         </div>
       )} */}
          </div>
        )}
      </div>
    </>
  );
};
export default Filters;
